var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineTelescope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.41 11.19-3.2-4.78a.756.756 0 0 1 .21-1.04l5.66-3.79c.44-.3.97-.4 1.49-.3.52.1.97.4 1.27.84l1.82 2.71c.61.91.37 2.15-.55 2.76l-5.65 3.79c-.14.1-.28.14-.43.14-.24 0-.48-.12-.62-.33zm.83-1.46 5.03-3.37c.23-.15.29-.46.13-.68l-1.82-2.71a.487.487 0 0 0-.31-.21c-.13-.03-.26 0-.37.07L12.88 6.2l2.36 3.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.32 13.91-2.56-3.82a.746.746 0 0 1 .21-1.04l4.78-3.2c.17-.11.37-.15.56-.11.2.04.37.15.48.32l2.56 3.82c.23.34.14.81-.21 1.04l-4.78 3.2c-.13.08-.28.12-.42.12-.24 0-.48-.12-.62-.33zm.82-1.46 3.53-2.36-1.72-2.58-3.53 2.37 1.72 2.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.82 16.04-1.13-1.68c-.26-.39-.35-.85-.26-1.31.09-.46.35-.85.74-1.11L7.12 9.3c.34-.23.81-.14 1.04.21l2.24 3.34c.23.34.14.81-.21 1.04l-3.95 2.64a1.753 1.753 0 0 1-2.42-.49zm.19-2.87c-.11.08-.15.23-.07.35l1.13 1.68c.08.11.23.15.35.07l3.32-2.22-1.41-2.1-3.32 2.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 22.68a.746.746 0 0 1-.37-.99l4.49-9.8c.17-.38.62-.54.99-.37.38.17.54.62.37.99l-4.49 9.8a.75.75 0 0 1-.68.44c-.1 0-.21-.02-.31-.07z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.76 22.31-4.44-9.8c-.17-.38 0-.82.37-.99.37-.17.82 0 .99.37l4.44 9.8a.751.751 0 0 1-.68 1.06.73.73 0 0 1-.68-.44z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineTelescope);
export default __webpack_public_path__ + "static/media/vuesax-outline-telescope.cc1e20f00396d233ccd83b217d3824da.svg";
export { ForwardRef as ReactComponent };